<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <template slot="header">
            {{ header }}
            <b-button
              v-if="filters && filters.length"
              size="sm"
              variant="secondary"
              class="pull-right"
              @click="resetFilters"
            >Reset filters
            </b-button
            >
            <resource-actions :actions="actions" :endpoint="endpoint"/>
          </template>
          <resource-filters
            v-model="filters"
            v-if="filters && filters.length"
            class="mb-3"
          />
          <resource-table
            :endpoint="endpoint"
            :show-route="showRoute"
            v-model="filters"
            @inputActions="actions = $event"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import ResourceFilters from './ResourceFilters';
  import ResourceTable from './ResourceTable';
  import ResourceActions from "./ResourceActions";

  let timer = null;

  export default {
    props: {endpoint: {}, showRoute: {}, header: {}},
    components: {ResourceActions, ResourceTable, ResourceFilters},
    methods: {
      resetFilters() {
        this.filters.forEach((item, index) => {
          this.filters[index].value = null;
        });
      },
      storeFilters(value) {
        if (timer) clearTimeout(timer);

        timer = setTimeout(() => {
          const namespace = this.endpoint;

          localStorage.setItem(`${namespace}-filters`, JSON.stringify(value));
        }, 500);
      },
      autoLoadFilters() {
        const namespace = this.endpoint;

        const filters = localStorage.getItem(`${namespace}-filters`);

        if (filters) {
          this.filters = JSON.parse(filters);
        }
      },
    },
    data() {
      return {
        filters: [],
        actions: [],
      };
    },
    beforeMount() {
      this.autoLoadFilters();
    },
    watch: {
      filters: {
        handler(oldValue, newValue) {
          this.storeFilters(newValue);
        },
        deep: true,
      },
    },
  };
</script>
